module.exports = __webpack_public_path__ + "media/fotografia_reel.bbd670bb.mp4";